import React from 'react';
import { ProjectPhase, tabs } from '@/constants';
import { useNavigate } from 'react-router-dom';

interface TopBarProps {
  selectedTab: ProjectPhase;
  setSelectedTab: (tab: ProjectPhase) => void;
}

const TopBar: React.FC<TopBarProps> = ({ selectedTab, setSelectedTab }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className='logo'>
        <button onClick={() => navigate('/')}>
          <img
            src='/opoint_logo_transparent_background_scaled.png'
            alt='Opoint Logo'
          />
        </button>
      </div>
      <div className='tabs'>
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => {
              setSelectedTab(tab);
              navigate('/');
            }}
            className={selectedTab === tab ? 'active' : ''}
          >
            {tab}
          </button>
        ))}
      </div>
    </>
  );
};

export default TopBar;
